import { http } from '@/lib/http';

const BASE = '/api/v1/platform/test-data';

export type TestDataEntityType =
  | 'SALES_ORDER'
  | 'CUSTOMER'
  | 'INVENTORY_ITEM'
  | 'SUPPORT_REQUEST';

export type CleanupRunStatus =
  | 'RUNNING'
  | 'COMPLETED'
  | 'RESTORING'
  | 'RESTORED'
  | 'FAILED';

export interface MarkedEntity {
  markId: string;
  entityType: TestDataEntityType;
  entityId: string;
  label: string;
  sublabel?: string;
  note?: string | null;
  markedAt: string;
}

export interface CleanupPreview {
  counts: Record<string, number>;
  totalRows: number;
  conflicts: string[];
  /** Sales orders that reference a marked test item but aren't in scope
   *  yet — marking these resolves the item conflicts. */
  resolvableOrders: { id: string; orderNumber: string }[];
}

export interface CleanupRun {
  id: string;
  status: CleanupRunStatus;
  note?: string | null;
  rootSummary?: Record<string, number> | null;
  entityCounts?: Record<string, number> | null;
  totalRows: number;
  error?: string | null;
  startedAt: string;
  completedAt?: string | null;
  restoredAt?: string | null;
  triggeredById?: string | null;
}

export const testDataService = {
  listMarked: () => http.get<MarkedEntity[]>(`${BASE}/marked`),

  mark: (entityType: TestDataEntityType, entityIds: string[], note?: string) =>
    http.post<{ marked: number }>(`${BASE}/mark`, { entityType, entityIds, note }),

  unmark: (entityType: TestDataEntityType, entityIds: string[]) =>
    http.post<{ unmarked: number }>(`${BASE}/unmark`, { entityType, entityIds }),

  preview: () => http.get<CleanupPreview>(`${BASE}/preview`),

  cleanup: (note: string) =>
    http.post<{ runId: string; totalRows: number; counts: Record<string, number> }>(
      `${BASE}/cleanup`,
      { note },
    ),

  listRuns: () => http.get<CleanupRun[]>(`${BASE}/runs`),

  restore: (runId: string) =>
    http.post<{ runId: string; restoredRows: number }>(`${BASE}/runs/${runId}/restore`),
};
